"use client"

import { ReactLenis } from "lenis/react"

interface LenisScrollerProps {
    children: React.ReactNode
}

export function LenisScroller({ children }: LenisScrollerProps) {
    return <ReactLenis root>{children}</ReactLenis>
}
